import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MultiSelect, {
      class: "me-2 min-heig-multiselect",
      mode: "single",
      searchable: true,
      options: _ctx.data,
      "close-on-select": true,
      "clear-on-select": false,
      trackBy: "name",
      valueProp: "viewId",
      modelValue: _ctx.selectedView,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedView) = $event)),
      object: true,
      label: "name",
      placeholder: "Visões",
      onSelect: _ctx.changeView,
      onClear: _ctx.clear,
      style: {"width":"200px"},
      ref: "inputMulti"
    }, {
      clear: _withCtx(({ clear }) => [
        _createElementVNode("button", {
          type: "button",
          onClick: ($event: any) => (clear()),
          class: "multiselect-clear",
          "aria-label": "Limpar a visão selecionada",
          title: "Limpar a visão selecionada"
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", {
            class: "multiselect-clear-icon",
            "aria-hidden": "true"
          }, null, -1)
        ]))], 8, _hoisted_1),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteView && _ctx.deleteView(...args))),
          class: "multiselect-clear",
          "aria-label": "Excluir a visão selecionada",
          title: "Excluir a visão selecionada"
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", {
            style: {"color":"red"},
            class: "mdi mdi-trash-can-outline",
            "aria-hidden": "true"
          }, null, -1)
        ]))])
      ]),
      _: 1
    }, 8, ["options", "modelValue", "onSelect", "onClear"]),
    _createElementVNode("button", {
      title: "Nova visão",
      class: "btn btn-primary btn-sm",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.salvarView && _ctx.salvarView(...args))),
      "aria-label": "Nova visão"
    }, [...(_cache[5] || (_cache[5] = [
      _createElementVNode("span", {
        class: "ri-menu-add-line",
        "aria-hidden": "true"
      }, null, -1)
    ]))])
  ], 64))
}